export function isAmazonMarketplace(marketplace: string) {
  return marketplace.trim().toLowerCase() === "amazon";
}

export function getMarketplaceFulfillmentLabel(marketplace: string) {
  return isAmazonMarketplace(marketplace) ? "Prime" : "Full";
}

export function getMarketplaceFulfillmentDescription(marketplace: string) {
  return isAmazonMarketplace(marketplace)
    ? "Indica que o produto faz parte da entrega Prime da Amazon."
    : "Indica que o produto está no estoque do marketplace com entrega Full.";
}

export function getMarketplaceFulfillmentIcon(marketplace: string) {
  return isAmazonMarketplace(marketplace) ? "ri-amazon-line" : "ri-box-3-line";
}
